import { useState } from "react";
import SearchCustomer from "./SearchCustomer";
import SearchStockList from "./SearchStockList";
import MoneyReceiptForm from "../MoneyReceiptForm";
import { arrayMap, arrayTextPrint } from "../../../utils/array.utils";
import StepTimeline from "./StepTimeline";
import { quotationFormatter } from "../../../utils/quotation.utils";
import { useNavigate } from "react-router-dom";

export default function MoneyReceiptStep({ title, editItem, existCustomer, redirectTo }) {
  const navigate = useNavigate();
  const editFormattedItem = quotationFormatter(editItem);

  // is exist customer? that means add from already have customer information through route state
  const isExistCustomer = !!existCustomer?.profile?.id;

  const [step, setStep] = useState({
    customer: editFormattedItem?.customer
      ? editFormattedItem?.customer
      : isExistCustomer
        ? existCustomer
        : existCustomer?.qoutToMr?.customer
          ? existCustomer?.qoutToMr?.customer
          : null,
    car: editFormattedItem?.car
      ? editFormattedItem?.car
      : existCustomer?.qoutToMr?.car
        ? existCustomer?.qoutToMr?.car
        : null,
    currentStep: editFormattedItem?.id
      ? 3
      : isExistCustomer
        ? 2
        : existCustomer?.qoutToMr?.car && existCustomer?.qoutToMr?.customer
          ? 3
          : 1,
    customerSearch: editFormattedItem?.cid ?? "",
    carSearch: editFormattedItem?.car?.chassis ?? "",
    isMultiQuot:
      typeof editFormattedItem?.is_multi === "boolean" ? editFormattedItem?.is_multi : false,
    multiCars: editFormattedItem?.car?.length ? editFormattedItem?.car : []
  });

  const onBack = () => {
    if (!!existCustomer?.qoutToMr?.customer?.profile?.id)
      return navigate(redirectTo ?? "/money-receipt-list");

    if (isExistCustomer && existCustomer?.profile?.customer_id) {
      if (step?.currentStep === 3) {
        setStep((prev) => ({ ...prev, currentStep: prev.currentStep - 1 }));
      } else {
        navigate(redirectTo);
      }
    } else {
      setStep((prev) => ({ ...prev, currentStep: prev.currentStep - 1 }));
    }
  };

  const customer = step?.customer ?? null;
  const car = step?.car ?? null;
  const descriptions =
    car?.descriptions ?? (car?.features?.length ? arrayTextPrint(car?.features) : "");

  let defaultValues = {
    customer: {
      name: customer?.profile?.name ?? "",
      designation: customer?.profile?.designation ?? "",
      mobile: customer?.profile?.mobile ?? "",
      email: customer?.profile?.email ?? "",
      address: customer?.address ?? "",
      customer_id: customer?.profile?.id ?? "",
      bank_name: customer?.loan?.bank_name ?? "",
      branch_name: customer?.loan?.branch_name ?? "",
      bank_will_pay: customer?.loan?.bank_will_pay ?? "",
      customer_will_pay: customer?.loan?.customer_will_pay ?? "",
      unit_price: customer?.loan?.unit_price ?? "",
      pay_order_collector_name: customer?.loan?.pay_order_collector_name ?? "",
      delivery_services: customer?.delivery?.delivery_services ?? "",
      delivery_papers: customer?.delivery?.delivery_papers ?? "",
      expected_delivery_date: customer?.delivery?.expected_delivery_date ?? ""
    },
    qoutDate: editFormattedItem?.qoutDate ? editFormattedItem.qoutDate : new Date(),
    validUntil: editFormattedItem?.validUntil ? editFormattedItem.validUntil : "",
    id: editFormattedItem?.id ? editFormattedItem.id : "",
    multiCars: step.multiCars,
    isMultiQuot: step.isMultiQuot,
    amount: editFormattedItem?.amount ?? ""
  };

  if (step.isMultiQuot) {
    defaultValues.car =
      arrayMap(step?.multiCars, (item, index) => {
        return {
          stock_list_id: item?.id ?? "",
          sku: item?.sku ?? "",
          name: item?.name ?? "",
          chassis: item?.fullChassis ?? "",
          engine: item?.engine ?? "",
          year: item?.year ?? "",
          color: item?.color ?? "",
          cc: item?.cc ?? "",
          fuel: item?.fuel ?? "",
          descriptions: item?.features?.length ? arrayTextPrint(item?.features) : "",
          price: item?.price ?? "",
          registration_cost: item?.registration_cost ?? "",
          total: item?.total ?? "",
          inwords: item?.inwords ?? ""
        };
      }) || [];
  } else {
    defaultValues.car = {
      stock_list_id: car?.id || "",
      sku: car?.sku || "",
      name: car?.name || "",
      chassis: car?.fullChassis || "",
      engine: car?.engine || "",
      brta_reg: car?.brta_reg || "",
      year: car?.year || "",
      color: car?.color || "",
      cc: car?.cc || "",
      fuel: car?.fuel || "",
      descriptions,
      price: car?.discount_price || car?.price || "",
      registration_cost: car?.registration_cost || "",
      discount: car?.discount || "",
      additionalCost: car?.additionalCost || ""
    };
  }

  return (
    <>
      <div className="row">
        <div className="col-12 col-md-6 mx-auto">
          <StepTimeline step={step} />
          {step.currentStep === 1 && <SearchCustomer step={step} setStep={setStep} />}
          {step.currentStep === 2 && (
            <SearchStockList step={step} setStep={setStep} onBack={onBack} />
          )}
        </div>
        {step.currentStep === 3 && (
          <MoneyReceiptForm
            existCustomer={existCustomer}
            title={title}
            defaultValues={defaultValues}
            onBack={onBack}
            redirectTo={redirectTo}
          />
        )}
      </div>
    </>
  );
}
